import { render } from "./TheCarTypeCreationForm.vue?vue&type=template&id=97b81e62"
import script from "./TheCarTypeCreationForm.vue?vue&type=script&lang=js"
export * from "./TheCarTypeCreationForm.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__